import React, { Component } from 'react'
import {
	Section,
	Container,
	StyledContainerReverseRounded,
} from './style.style'
import { LightDatePicker } from '../../../components/form-components'
import { SelectSearchBar } from './components/select-search-bar/select-search-bar'
import { SelectSearchBarAsync } from './components/select-search-bar-async/select-search-bar-async.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { PRIORITY_TERM, tripStage } from '../../../constants/trip.constants'
import FontAwesome from 'react-fontawesome'
import Button from './buttons.component'
import moment from 'moment'
import TicketSaleService from '../../../services/ticket-sale.service'
import {
	getDestinyDefaultValue,
	getDateFormatted,
	sortTerminalsByPriority,
	dateHelper,
} from '../../../../src/helpers'
import { getViewableLocations } from '../../../helpers/trip-search.helper'
import { breakpoints } from '../../../constants'
import './style.css'
class IFramePlanalto extends Component {
	constructor() {
		super()
		moment.locale('pt-br')
		this.state = {
			selectedOrigin: null,
			originOptions: [],
			selectedDestiny: null,
			destinyOptions: [],
			filteredDestinyOptions: [],
			dateGoing: moment(new Date()),
			shouldFocusOnDateGoing: false,
			dateReturn: null,
			shouldFocusOnDateReturn: false,
		}
	}

	componentDidMount() {
		let defaultDateGoingSearch = dateHelper.getTomorrowDate()
		this.setState({ dateGoing: moment(defaultDateGoingSearch) })
	}

	loadOrigins = (inputValue, callback) => {
		const { originOptions } = this.state
		if (!inputValue && (!originOptions || originOptions.length === 0)) {
			const { user, muvibus } = this.props
			TicketSaleService.getOrigins({
				muvibusState: !!muvibus,
				isPublicBody: user ? user.hasPublicBody : null,
				userId: user ? user.id : null,
			}).then((response) => {
				if (response.success) {
					this.setState({
						originOptions: response.data,
					})
					callback(getViewableLocations(response.data))
				}
			})
		} else {
			if (!!inputValue) {
				const filter = originOptions.filter((origin) =>
					origin.city
						.toUpperCase()
						.normalize('NFD')
						.replace(/[\u0300-\u036f]/g, '')
						.includes(
							inputValue
								.toUpperCase()
								.normalize('NFD')
								.replace(/[\u0300-\u036f]/g, '')
						)
				)
				callback(getViewableLocations(filter))
			} else {
				callback(getViewableLocations(originOptions))
			}
		}
	}

	handleOriginSelected = (newOrigin) => {
		this.setState({
			selectedOrigin: newOrigin,
		})
		if (!newOrigin) {
			this.cleanDestinyOptions()
			return
		}

		const { user, muvibus } = this.props

		TicketSaleService.getDestinations({
			id: newOrigin.id,
			isMuvibus: muvibus,
			isPublicBody: user ? user.hasPublicBody : null,
			userId: user ? user.id : null,
			hasChildren: newOrigin.hasChildren,
		})
			.then((response) => {
				if (response.success) {
					this.setState({
						destinyOptions: sortTerminalsByPriority(
							response.data,
							PRIORITY_TERM
						),
						filteredDestinyOptions: sortTerminalsByPriority(
							response.data,
							PRIORITY_TERM
						),
						selectedDestiny: null,
					})
				} else {
					this.cleanDestinyOptions()
				}
			})
			.catch((error) => {
				this.cleanDestinyOptions
			})
	}

	cleanDestinyOptions = () => {
		this.setState({
			destinyOptions: [],
			filteredDestinyOptions: [],
			selectedDestiny: null,
		})
	}

	handleDestinySelected = (newDestiny) => {
		const { destinyOptions } = this.state
		const filteredDestinyOptions = [...destinyOptions]

		this.setState({
			selectedDestiny: newDestiny,
			filteredDestinyOptions,
		})
	}

	reverseDestination = () => {
		const { selectedOrigin, selectedDestiny, originOptions } = this.state
		if (
			!!selectedOrigin &&
			!!selectedOrigin.city &&
			!!selectedDestiny &&
			!!selectedDestiny.city
		) {
			const lastOrigin = { ...selectedOrigin }
			const newSelectedOrigin = originOptions.find(
				(origin) =>
					origin.city === selectedDestiny.city &&
					origin.ibgeCode === selectedDestiny.ibgeCode
			)
			this.setState({
				selectedOrigin: newSelectedOrigin,
			})

			const { user, muvibus } = this.props

			TicketSaleService.getDestinations({
				id: newSelectedOrigin.id,
				isMuvibus: muvibus,
				isPublicBody: user ? user.hasPublicBody : null,
				userId: user ? user.id : null,
				hasChildren: selectedDestiny.hasChildren,
			})
				.then((response) => {
					if (response.success && !!response.data) {
						const newSelectedDestiny = response.data.find(
							(destiny) => destiny.city === lastOrigin.city
						)
						this.setState({
							destinyOptions: sortTerminalsByPriority(
								response.data,
								PRIORITY_TERM
							),
							filteredDestinyOptions: sortTerminalsByPriority(
								response.data,
								PRIORITY_TERM
							),
							selectedDestiny: newSelectedDestiny,
						})
					} else {
						this.cleanDestinyOptions()
					}
				})
				.catch(this.cleanDestinyOptions)
		}
	}

	searchForTrips = () => {
		const { selectedOrigin, selectedDestiny, dateGoing, dateReturn } =
			this.state

		const dateReturnFormatted = getDateFormatted(dateReturn)

		const dateReturnPart = !!dateReturnFormatted ? dateReturnFormatted : null

		const url =
			'/compra-de-passagem?' +
			`IdOrigem=${selectedOrigin.id}` +
			`&IdDestino=${selectedDestiny.id}` +
			`&DestinoCity=${selectedDestiny.city}` +
			`&OriginCity=${selectedOrigin.city}` +
			`&Empresa=${selectedDestiny.busCompany}` +
			`&DataIda=${getDateFormatted(dateGoing)}` +
			`&DataVolta=${dateReturnPart}` +
			'&PortalOrigem=Planalto' +
			`&hasChildren=${selectedOrigin.hasChildren}`

		window.parent.location = url
	}

	getSearchButtonIsDisabled = () => {
		const { selectedOrigin, selectedDestiny, dateGoing } = this.state
		let searchDisabled = true
		if (
			!!selectedOrigin &&
			!!selectedOrigin.city &&
			!!selectedDestiny &&
			!!selectedDestiny.city &&
			!!dateGoing
		) {
			searchDisabled = false
		}
		return searchDisabled
	}

	handleDestinyInputChange = (rawInput) => {
		const { destinyOptions } = this.state
		const input = rawInput
			.toUpperCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
		let filteredDestinyOptions
		if (!input) {
			filteredDestinyOptions = [...destinyOptions]
		} else {
			filteredDestinyOptions = destinyOptions.filter((destiny) => {
				const city = destiny.city
					.toUpperCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
				return city.includes(input) || input.includes(city)
			})
		}
		this.setState({ filteredDestinyOptions })
	}

	render() {
		const {
			selectedOrigin,
			originOptions,
			selectedDestiny,
			destinyOptions,
			filteredDestinyOptions,
			dateGoing,
			dateReturn,
			shouldFocusOnDateGoing,
			shouldFocusOnDateReturn,
		} = this.state
		const destinyPlaceholder = getDestinyDefaultValue(
			selectedOrigin,
			selectedDestiny,
			destinyOptions
		)
		const searchDisabled = this.getSearchButtonIsDisabled()
		const isMobile = window.innerWidth < breakpoints.MOBILE_IFRAME_PLANALTO
		return (
			<Section>
				<Container>
					<SelectSearchBarAsync
						onChange={this.handleOriginSelected}
						value={selectedOrigin}
						loadOptions={this.loadOrigins}
						options={originOptions}
						placeholder={tripStage.ORIGIN}
						maxMenuHeight={isMobile ? 240 : 230}
						defaultOptions
						cache
					/>
					<StyledContainerReverseRounded className="container-reverse">
						<FontAwesome
							className="ico-reverse"
							name="exchange"
							title="Inverter destino"
							onClick={this.reverseDestination}
							id="ico-reverse"
						/>
					</StyledContainerReverseRounded>
					<SelectSearchBar
						onChange={this.handleDestinySelected}
						value={selectedDestiny}
						options={filteredDestinyOptions}
						placeholder={destinyPlaceholder}
						maxMenuHeight={isMobile ? 190 : 230}
						onInputChange={this.handleDestinyInputChange}
					/>
					<LightDatePicker
						placeholder="Data de ida"
						date={dateGoing}
						onDateChange={(dateGoing) => this.setState({ dateGoing })}
						focused={shouldFocusOnDateGoing}
						onFocusChange={(shouldFocusOnDateGoing) =>
							this.setState({ shouldFocusOnDateGoing })
						}
						withPortal={isMobile}
						id="dateGoing"
						daySize={isMobile ? 40 : 25}
						showClearDate={false}
						isOutsideRange={(value) => {
							return (
								value.isBefore(moment().startOf('day')) ||
								value.isAfter(moment().startOf('day').add(24, 'M')) ||
								value
									.startOf('day')
									.isAfter(
										moment(dateReturn, 'YYYY-MM-DD').startOf('day')
									)
							)
						}}
					/>
					<LightDatePicker
						showClearDate={true}
						placeholder="Data de Volta"
						date={dateReturn}
						withPortal={isMobile}
						onDateChange={(dateReturn) => this.setState({ dateReturn })}
						focused={shouldFocusOnDateReturn}
						onFocusChange={(shouldFocusOnDateReturn) =>
							this.setState({ shouldFocusOnDateReturn })
						}
						id="dateReturn"
						daySize={isMobile ? 40 : 25}
						isOutsideRange={(value) => {
							return (
								value.isBefore(moment().startOf('day')) ||
								value
									.startOf('day')
									.isBefore(
										moment(dateGoing, 'YYYY-MM-DD').startOf('day')
									)
							)
						}}
					/>
					<Button
						disabled={searchDisabled}
						primary
						onClick={this.searchForTrips}
						type="button"
						style={{
							minWidth: '10%',
							height: '42px',
							padding: '0',
							fontSize: '18px',
						}}
						className="col-2">
						Buscar
					</Button>
				</Container>
			</Section>
		)
	}
}

const connectedLaunch = withRouter(connect(null)(IFramePlanalto))
export { connectedLaunch as ModuleRootComponent }
